import { ACCOUNT_CHANGE_DATA_STATE, ACCOUNT_CHANGE_FILTER } from '@/constant/redux-const';
import { DEFAULT_PAGE_SIZE } from '@/utils/constant';

const initialState = {
  dataState: {
    sort: [ { field: 'createdAt', dir: 'desc' } ],
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
  },
  accountFilter: {},
};

const AccountListReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case ACCOUNT_CHANGE_FILTER:
      return {
        ...state,
        accountFilter: { ...action.payload },
      };
    case ACCOUNT_CHANGE_DATA_STATE:
      return {
        ...state,
        dataState: { ...action.payload },
      };
    default:
      return state;
  }
};
export default AccountListReducer;
